import * as React from "react";
import { IAuthData } from "../types";

export const AuthContext = React.createContext<IAuthData>({} as IAuthData);

AuthContext.displayName = "AuthContext";
